import { Close } from '@mui/icons-material';
import { Box, Dialog, DialogContent, IconButton } from '@mui/material';

const HireflixEmbedTourModal = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xl"
      sx={{
        '& .MuiPaper-root': {
          position: 'relative',
        },
      }}
    >
      <DialogContent sx={{ padding: '0 !important' }}>
        <IconButton
          sx={{ position: 'absolute', top: 0, right: 0, zIndex: '2' }}
          onClick={onClose}
        >
          <Close />
        </IconButton>
        {/* ARCADE EMBED START */}
        <Box
          sx={{
            position: 'relative',
            paddingBottom: 'calc(48.3% + 0px)',
            height: '0px',
            width: '100%',
          }}
        >
          <iframe
            src="https://demo.arcade.software/bpYMyM2ppstisNlKIgY1?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true"
            title="Create and Send a Hireflix Video Interview Invitation"
            // frameBorder="0"
            loading="lazy"
            // @ts-ignore
            webkitAllowFullScreen
            // @ts-ignore
            mozAllowFullScreen
            allowFullScreen
            allow="clipboard-write"
            style={{
              position: 'absolute',
              top: '0',
              left: '0',
              width: '100%',
              height: '100%',
              colorScheme: 'light',
              border: '0 !important',
            }}
          />
        </Box>
        {/* ARCADE EMBED END */}
      </DialogContent>
    </Dialog>
  );
};

export default HireflixEmbedTourModal;
